import htmlToDom from '../../../../helpers/htmlToDom';

export default (text, link) =>
	htmlToDom(`
        <li>
            <a class="search-result" href="${link}">${text}</a>
        </li>
    `);
